import React from 'react';
import { TextButton } from '@oneaudi/unified-web-components';
import { usePostData } from '../CTA';
import { useVehicleRaw } from '../../../../../hooks';
import { dynamicStylingHelper } from '../../../../utils/AlphaHelper';
const PostButton = ({ buttonInfo, variant, vehicle, trackButtonClick, isMobileScreenSize, isLoading, }) => {
    const { vehicleRaw } = useVehicleRaw(vehicle.id);
    const postData = typeof document !== 'undefined' && usePostData(vehicle, buttonInfo === null || buttonInfo === void 0 ? void 0 : buttonInfo.dataProfile, vehicleRaw);
    const { label, url, target, type } = buttonInfo;
    return (React.createElement("form", { method: "post", "data-testid": "post-button-form", action: url, target: target === 'new-window' ? '_blank' : '_self' },
        React.createElement(TextButton, { onClick: () => {
                trackButtonClick(buttonInfo, variant, buttonInfo.trackingCode);
            }, variant: variant, href: "", "data-testid": `${type}-button-variant-${variant}`, target: target === 'new-window' ? '_blank' : '_self', "data-tracking-exclude": true, isFullWidth: isMobileScreenSize, isLoading: isLoading, size: dynamicStylingHelper('md', 'sm') }, label),
        React.createElement("input", { type: "hidden", name: "inquiry_json_data", value: postData })));
};
export default PostButton;
